export const isPlanAdminUser = (user) => Boolean(
  user && (user.role === "owner" || user.is_superadmin || user.is_coadmin)
);

export const canCreateDienstplan = (user) => Boolean(user);

export const getDefaultHomePath = (user) => {
  if (isPlanAdminUser(user)) return "/dienstplan";
  if (user && !String(user.dienstplan_id || "").trim()) return "/dienstplan";
  return "/member";
};

export const canManagePlan = (plan) => Boolean(
  plan && (
    plan.can_manage ||
    plan.is_owner ||
    plan.is_superadmin ||
    plan.is_coadmin ||
    ["owner", "superadmin", "coadmin"].includes(String(plan.access_role || "").toLowerCase())
  )
);

export const getPlanHomePath = (plan) => (canManagePlan(plan) ? `/dienstplan/${plan.id}` : "/member");
